export default __webpack_public_path__ + "assets/logo-small.e5ee8f8.png";